import {
  getRegions,
  getRegionsTemplate,
  getPriceRegions,
  createpriceRegion,
  getStates,
  editpriceRegion,
  deletepriceRegion,
} from "@/http/setup/priceRegion.js";

export default {
  namespaced: true,
  state: {
    RegionsList: {},
    RegionsTemplateList: {},
    PriceRegionList: {},
    createpriceRegion: null,
    GetState: {},
  },
  actions: {
    async setRegions({ commit }) {
      try {
        const resp = await getRegions();
        commit("SET_REGIONS", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setRegionsTemplate({ commit }) {
      try {
        const resp = await getRegionsTemplate();
        commit("SET_REGIONS_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setPriceRegions({ commit }, id) {
      try {
        const resp = await getPriceRegions(id);
        commit("SET_PRICE_REGION", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createpriceRegionAction({ commit }, data) {
      try {
        const resp = await createpriceRegion(data);
        commit("CREATE_PRICE_REGION_ACTION", resp.data.resourceId);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getStatesAction({ commit }, data) {
      try {
        const resp = await getStates(data.id, data.data);
        commit("GET_STATES_ACTIONS", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editpriceRegionAction({ commit }, data) {
      try {
        const resp = await editpriceRegion(data.id, data.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deletepriceRegionAction({ commit }, id) {
      try {
        const resp = await deletepriceRegion(id);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_REGIONS(state, payload) {
      state.RegionsList = payload;
    },
    SET_REGIONS_TEMPLATE(state, payload) {
      state.RegionsTemplateList = payload;
    },
    SET_PRICE_REGION(state, payload) {
      state.PriceRegionList = payload;
    },
    CREATE_PRICE_REGION_ACTION(state, payload) {
      state.createpriceRegion = payload;
    },
    GET_STATES_ACTIONS(state, payload) {
      state.GetState = payload;
    },
  },
  getters: {
    getRegionsList(state) {
      return state.RegionsList;
    },
    savePriceRegionResponse(state) {
      return state.createpriceRegion;
    },
  },
};
